import CorrectTierCard from './CorrectTierCard.component';

export default CorrectTierCard;
